module.exports = __webpack_public_path__ + "static/media/new-nginx.8d4cb39b.svg";